module.exports = __webpack_public_path__ + "static/media/timeline.63810924.png";